import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/settings/webhooks/$id')({
  component: () => null,
});
